import Global from "./Global";
import user from "./User";
import FormValidator from "./FormValidator";
import MainNav from "./MainNav";
import Search from "./Search";
import FilterPanel from "./FilterPanel";
import Card from "./Card";
import Share from "./Share";
import Modal from "./Modal";
import Favourites from "./Favourites";
import Course from "./Course";
import BlockAccordion from "./BlockAccordion";
import News from "./News";
import CalendarEvent from "./CalendarEvent";
import NewOnDigiteketLoadMore from "./LatestPosts";

const app = {
  init: () => {
    document.addEventListener("DOMContentLoaded", () => {
      Global.init();
      MainNav.init();
      Search.init();
      FilterPanel.init();
      FormValidator.init();
      Card.init();
      Share.init();
      Modal.init();
      Favourites.init();
      Course.init();
      BlockAccordion.init();
      News.init();
      CalendarEvent.init();
      const latestPosts = new NewOnDigiteketLoadMore({
        btnId: "latest-posts-load-more",
        resultsId: "results",
        action: "digi_latest_posts_load_more",
        loadingText: "Laddar...",
        doneText: "Ladda fler",
      });
    });
  },
  getUser: () => {
    return user;
  },
  countCards: () => {
    // count nr of cards on the page
    let output = "There are no cards on the page.";
    const countedCards = Array.from(document.querySelectorAll(".card"));

    if (countedCards) {
      output = `Cards on page: ${countedCards.length}!`;
    }

    console.log(output);
  },
};

// add countCards to the window obj
window.cards = app.countCards;

app.init();
